import { render, staticRenderFns } from "./operateAccount.vue?vue&type=template&id=f1b6caf4&scoped=true&"
import script from "./operateAccount.vue?vue&type=script&lang=js&"
export * from "./operateAccount.vue?vue&type=script&lang=js&"
import style0 from "./operateAccount.vue?vue&type=style&index=0&id=f1b6caf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b6caf4",
  null
  
)

export default component.exports